<template>
<div>
  <p>{{name}}</p>
  <p>{{value}}</p>
</div>
</template>

<script>
import filters from 'common/filters.js'
export default {
  props: ['name', 'value'],
  filters: {
    format_percentage: filters.format_percentage
  }
}
</script>

<style scoped>

</style>
